import { TimecodeListValueGet, Ulid } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { TimeCodeValue } from "./interfaces";

export const makeCode = ({ connection, company }: ApiSliceParams) => {
    const {
        items: values,
        listen,
        loading,
    } = createListController<
        TimecodeListValueGet,
        TimeCodeValue,
        Readonly<Ulid>
    >({
        connection,
        list: (con, id) =>
            con.timecodeList.values.items({ company: company.value, id }),
        getKey: (id) => id.toString(),
        name: "timeCodeValue",
    });

    const listenMany = (ids: readonly Readonly<Ulid>[]) =>
        ids.forEach((id) => listen(id));

    const getFor = (id: Readonly<Ulid> | null | undefined) => {
        if (!id) {
            return [];
        }

        return values.value.filter((value) => value.parent.equals(id));
    };

    return { loading, listenMany, getFor };
};
